import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const SUBMIT_ADP_REFERRAL_MUTATION = gql`
  mutation SubmitAdpReferralMutation($input: AdpReferralInput!) {
    submitAdpReferral(input: $input)
  }
`;

export function useAdpReferralSubmit() {
  const [submitAdpReferralMutation, { error, loading }] = useMutation(SUBMIT_ADP_REFERRAL_MUTATION, {
    noThrow: true,
  });

  const submitAdpReferral = useCallback(
    async (input) => {
      const response = await submitAdpReferralMutation({
        variables: { input },
      });

      return Boolean(response?.data?.submitAdpReferral);
    },
    [submitAdpReferralMutation],
  );

  useError(error);

  return {
    submitAdpReferral,
    loading,
    hasError: Boolean(error),
  };
}
